import React, { useCallback, useMemo, useState } from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/ECFront'

import PrivateSaleRegistration from '@/PrivateSaleRegistration'
import FormStatus              from '@/Form/FormStatus'

import Loader from '@Pure/Loader'

import LoadPrivateSale from '@fetcher/LoadPrivateSale'

export default PageWrapper(function PrivateSalePage (props)
{
	const [private_sale, setPrivateSale] = useState();
	const [loading, setLoading] = useState(true);
	const [status, setStatus] = useState({ });

	const onSuccess = useCallback(function (private_sale)
	{
		setPrivateSale(private_sale);
		setLoading(false);
	},
	[]);

	const onError = useCallback(function (status)
	{
		setStatus(status.info ? { info: status.info } : status);
		setLoading(false);
	},
	[]);

	const onRegister = useCallback(function (response)
	{
		setPrivateSale(undefined);
		setStatus({ info: response.info });
		setLoading(false);
	},
	[]);

	const title = useMemo(function ()
	{
		let title = private_sale?.title || '';

		if (!title)
		{
			title = 'Vente privée';
		}
		else if (!title.includes('privée'))
		{
			title = 'Vente privée ' + title;
		}

		return title;
	},
	[private_sale?.title]);

	return (
		<Layout page_title={ title } history={ props.history }>

			<div className="page-content">

				<FormStatus { ...status } />

				{
					private_sale ?
					(
						<PrivateSaleRegistration data={ private_sale }
							onRegister={ onRegister } />
					)
					: loading ?
					(
						<Loader className="c-loader"
							bemit={ ['primary', 'bg-light', 'medium'] }
						/>
					)
					: undefined
				}

			</div>

			<LoadPrivateSale slug={ props.match.params?.slug }
				onSuccess={ onSuccess }
				onError={ onError }
			/>

		</Layout>
	);
});